module.exports = __webpack_public_path__ + "media/MRI8.4db024ba.mp3";